/**
 * Mirrors packages/amgroulette_v2/lib/presentation/rive/rive_inputs.dart
 *
 * The Roulette .riv files have a couple of notable quirks:
 *   - Some trigger names have a TRAILING SPACE (`'RouletteTrigger '`,
 *     `'ResultTrigger '`) — this is how they were exported from the editor.
 *     Strip-and-retry fallbacks live in riveLayer.ts.
 *   - `winnungBarNumber` is a typo in the .riv export; kept as-is to match
 *     the runtime input name.
 */

export const MainInputs = {
  stateMachine: 'MainStageMachine',
  /** Girl-animation type. 0=init, 1=lets-play, 2=take-chip. */
  girlAnim: 'GirlAnimSeltion',
  /** Plays whatever GirlAnim selection is set. */
  trigGirlAnim: 'GirlAnimplay',
  trigStartBet: 'trigStartBet',
  trigNoMoreBet: 'trigNoMoreBet',
  isSoundGameMain: 'isSoundGameMain',
} as const;

export const RouletteInputs = {
  stateMachine: 'RouletteStageMachine',
  /** Set BEFORE firing RouletteTrigger — picks the slot the ball will land in. */
  roulettePanelNumber: 'RoulettePanelNumber',
  /** Starts the wheel spin. NOTE: has a trailing space in the .riv. */
  trigSpin: 'RouletteTrigger ',
  /** Set BEFORE firing ResultTrigger — drives the post-spin result panel. */
  resultNumber: 'ResultNumber',
  /** Starts the result panel animation. NOTE: trailing space in the .riv. */
  trigResult: 'ResultTrigger ',
  /** Highlighted number on the side-bar history strip. */
  winningBarNumber: 'winnungBarNumber',
  rouletteNum: 'rouletteNum',
  hoverNumber: 'hoverNumber',
  isSoundFXGame1: 'isSoundFXGame1',
} as const;

export const BettingInputs = {
  stateMachine: 'MainStageMachine',
  /** Boolean — true on desktop / false on mobile (mouse hover state). */
  isMouse: 'isMouse',
  hoverNumber: 'BetPanelNumber1',
} as const;

/** MainWinLose.riv inputs — popups + win/lose panel. */
export const WinLoseInputs = {
  stateMachine: 'animationManager',
  /** Number: 1=StartBet, 2=NoMoreBet popups; YouWinLose plays 1=Win 2=Lose. */
  betPanelNumber: 'BetPanelNumber',
  trigBetPanel: 'BetPanelTrigger',
  youWinLose: 'YouWinLose',
  trigYouWinLose: 'YouWinLoseTrigger',
  txtWonAmount: 'txtWonAmount',
} as const;

export const TextInputs = {
  balance: 'txtBalance',
  betAmount: 'txtBetAmount',
  winAmount: 'txtWinAmount',
  minBet: 'txtMinBet',
  maxBet: 'txtMaxBet',
} as const;

export const RiveEventNames = {
  placeBetClick: 'placeBetClick',
  clickChips: 'evtClickChips',
  clearClick: 'evtClearClick',
  playClick: 'evtButtonPlayClick',
  ballStop: 'evtBallStop',
  resultStop: 'evtResultStop',
  bet36: 'evt36Bet',
  betCross: 'evtCrossBet',
  uiButtonClick: 'UIButtonClick',
} as const;
